import { Row } from "@stenajs-webui/core";
import { ModalHeading } from "@stenajs-webui/modal";
import type { FC, ReactNode } from "react";

import { BookingStatusTag } from "../../../../common-ui/BookingStatusTag";
import { ModalHeaderContainer } from "../../../../common-ui/modal/ModalHeaderContainer";
import { PaymentStatusLabel } from "../../../../common-ui/payment/PaymentStatusLabel";
import type { DetailedBooking } from "../../../../common/graphql/fragments/gql/DetailedBooking";

interface BookingDetailsHeaderProps {
  booking: DetailedBooking;
  bookingActions: ReactNode;
  className: string;
  onRequestClose: () => void;
}

export const BookingDetailsHeader: FC<BookingDetailsHeaderProps> = ({
  booking,
  className,
  onRequestClose,
  bookingActions,
}) => {
  return (
    <ModalHeaderContainer className={className} onRequestClose={onRequestClose}>
      <ModalHeading>{String(booking.bookingNo)}</ModalHeading>
      <Row gap={2}>
        <BookingStatusTag
          status={booking.bookingStatus}
          quayStatus={booking.bookingQuayStatus}
        />
        <PaymentStatusLabel status={booking.paymentStatus} />
      </Row>
      {bookingActions}
    </ModalHeaderContainer>
  );
};
